import React from 'react';
import { motion } from 'framer-motion';
import { Settings, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../styles/design-system.css';

const ConstructionPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main className="flex-1 flex items-center justify-center py-20 mt-20">
        <div className="container max-w-2xl text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div 
              className="w-24 h-24 mx-auto mb-8 rounded-full flex items-center justify-center shadow-lg"
              style={{ background: 'var(--accent-gold-200)' }}
            >
              <Settings size={40} style={{ color: 'var(--text-primary)' }} className="animate-spin-slow" />
            </div>
            
            <h1 className="heading-1 mb-6">Página em Construção</h1>
            <p className="body-large mb-10" style={{ color: 'var(--text-secondary)' }}>
              Estamos preparando um espaço incrível para você. Em breve, mais informações 
              sobre nossos novos projetos, mentorias e iniciativas.
            </p>
            
            <button
              onClick={() => navigate('/')}
              className="btn-primary inline-flex items-center gap-2"
            >
              <ArrowLeft size={18} />
              Voltar para a Página Inicial
            </button>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ConstructionPage;
